import {Directive} from '@angular/core';
import {OnboardingComponent} from "@app/presentation/components/onboarding/onboarding.component";

@Directive({
  selector: '[customOnboardingNext]',
  host: {
    '(click)': 'onClickNextButton()'
  },
})
export class OnboardingButtonDirective {

  constructor(private onboarding: OnboardingComponent) { }

  onClickNextButton() {
    this.onboarding.next()
  }

}
